import { render, staticRenderFns } from "./payment.page.vue?vue&type=template&id=1115e5d8&scoped=true&"
import script from "./payment.page.vue?vue&type=script&lang=ts&"
export * from "./payment.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115e5d8",
  null
  
)

export default component.exports